export default class LanguageSwitcherElement     extends HTMLElement {

    connectedCallback() {
        const selectElement = this.querySelector('select');
        selectElement.addEventListener('change', function() {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('locale', this.value);
            window.location.href = currentUrl.toString();
        });
    }
};

window.customElements.define('language-switcher', LanguageSwitcherElement);

